import { Space, Table, Tag, Card, Flex, Col } from "antd"
import RegisterCategoryModal from "./RegisterCategoryModal";
import { useSelector, useDispatch } from 'react-redux';
import { getCategoriesAsync, getCategoryCountAsync, selectCategories, selectCategoryCount, selectCategoryFilterOptions } from "../../../app/store/reducers/category/categoryReducer";
import UpdateCategoryModal from "./UpdateCategoryModal";
import { useEffect } from "react";



const Categories = () => {
  const filter = useSelector(selectCategoryFilterOptions)
  const count = useSelector(selectCategoryCount)
  const categories = useSelector(selectCategories)
  const dispatch = useDispatch()

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text) => <b>{text}</b>,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      className: "d-flex justify-content-end",
      render: (_, record) =>{
        return (
          <UpdateCategoryModal category={record} />  
        )
      }
    },
  ];



  useEffect(() => {
    dispatch(getCategoriesAsync({...filter}))
    dispatch(getCategoryCountAsync({...filter}))
  },[filter])


  const handleTableChange = (pagination, filters, sorter) => {
    console.log("table", pagination, filters, sorter)
    // setTableParams({
    //   pagination,
    //   filters,
    //   ...sorter,
    // });

    // `dataSource` is useless since `pageSize` changed
    // if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      // setData([]);
    // }
  };


    return (
    <>
        <Card>
          <Flex align="center" justify="space-between" style={{borderBottom: "2px solid green"}}>
            <Col>
            <h4>Categories</h4>
            </Col>
            <Col>
              <RegisterCategoryModal />
            </Col>
          </Flex>
        <Table
          columns={columns} 
          // dataSource={data} 
          dataSource={categories}
          pagination={{
            current: filter.page,
            pageSize: filter.limit,
            total: count,
          }} 
          scroll={{
            // y: 240,
          }}
          onChange={handleTableChange}
          />
        </Card>
    </>
  )
}

export default Categories